import React from "react";
import { Star, Quote } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
const testimonials = [{
  text: "The legal team was exceptional. They handled my complex corporate litigation with precision and kept me informed at every stage of the process.",
  name: "Jonathan Sterling",
  role: "CEO, Sterling Dynamics",
  location: "New York, NY",
  pill: "Case Won"
}, {
  text: "I was facing a difficult property dispute that seemed endless. Their attorneys resolved it in weeks, saving me both time and significant legal fees.",
  name: "Elena Rodriguez",
  role: "Real Estate Developer",
  location: "Miami, FL",
  pill: "Fast Resolution"
}, {
  text: "Professional, strategic, and highly effective. They provided the clarity and protection our startup needed during our Series A funding round.",
  name: "Marcus Thorne",
  role: "Tech Founder",
  location: "San Francisco, CA",
  pill: "Strategic Counsel"
}];
export default function ContactForm() {
  return <section data-section-id="258391" id="contact-form" className="py-24 bg-background text-foreground">
      <div className="page-container">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-primary font-bold tracking-wider uppercase text-sm mb-4 font-default">
            Client Testimonials
          </h2>
          <h3 className="text-4xl md:text-5xl font-bold text-foreground mb-6 font-default">
            Trusted by Industry Leaders
          </h3>
          <p className="text-lg text-muted-foreground">
            Discover why businesses and individuals rely on our legal expertise to navigate their most challenging legal matters.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((item, i) => <Card key={i} data-index={i} className="relative overflow-hidden border border-border shadow-medium bg-background">
              <CardContent className="p-8 flex flex-col h-full">
                <Quote className="absolute top-6 right-6 size-12 text-primary/10 rotate-180" />

                <div className="flex gap-1 mb-6">
                  {[...Array(5)].map((_, j) => <Star key={j} className="size-5 fill-primary text-primary" />)}
                </div>

                <p className="text-foreground/80 leading-relaxed flex-grow text-base">
                  "{item.text}"
                </p>

                <div className="mt-8 pt-6 border-t border-border flex items-end justify-between gap-4">
                  <div>
                    <div className="font-bold text-foreground font-default">
                      {item.name}
                    </div>
                    <div className="text-sm text-muted-foreground mt-1">
                      {item.role}
                    </div>
                    {item.location && <div className="text-sm text-muted-foreground">
                        {item.location}
                      </div>}
                  </div>
                  {item.pill && <div className="bg-primary/10 text-primary text-xs font-semibold px-3 py-1.5 rounded-md text-right max-w-[130px] leading-tight">
                      {item.pill}
                    </div>}
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}